import jwtDecode from "jwt-decode";
import router from "@/router";
import { initState } from "./index";
import refreshToken from "@/services/refreshToken";

const AUTH_TOKEN = process.env.VUE_APP_AUTH_TOKEN_NAME;
const SSO_URL = process.env.VUE_APP_SSO_URL;

export default {
  login: ({ commit, dispatch }, payload) => {
    localStorage.setItem(AUTH_TOKEN, payload);
    const jwtExpDecode = jwtDecode(payload);
    dispatch("initMsToken", payload);
    commit("setAuth", jwtExpDecode);
    dispatch("checkTimeout", jwtExpDecode.exp);
  },
  logout: ({ commit }) => {
    localStorage.removeItem(AUTH_TOKEN);
    commit("setAuth", initState);
    window.location.replace(SSO_URL + "logout");
  },
  // Payload: timeout
  checkTimeout: ({ dispatch }, payload) => {
    const now = new Date();
    const expirationDate = new Date(payload * 1000);
    const expirationTime = expirationDate.getTime() - now.getTime();
    // if (expirationTime <= 0) {
    //   router.push("/auth/login");
    //   return;
    // }
    setTimeout(() => {
      dispatch("logout");
    }, expirationTime);
  },
  init: ({ dispatch, state }) => {
    const token = localStorage.getItem(AUTH_TOKEN) || state?.token;
    if (token) {
      dispatch("login", token);
    } else {
      // dispatch("logout");
      router.push("/auth/login");
    }
  },
  /**
   * MS TOKEN
   */
  // Payload: timeout
  checkTimeoutMsToken: ({ dispatch }, payload) => {
    const now = new Date();
    const expirationDate = new Date(payload * 1000);
    setTimeout(() => {
      dispatch("initMsToken", localStorage.getItem(AUTH_TOKEN));
    }, expirationDate.getTime() - now.getTime());
  },
  initMsToken: async ({ dispatch, commit }, payload) => {
    if (payload) {
      try {
        // Send a POST request
        const { data } = await refreshToken(payload);
        console.log("initMsToken > hasNewMsToken");
        if (data) {
          // set msToken
          commit("setMsToken", data);
          // call check timeout
          const jwtExpDecode = jwtDecode(data);
          dispatch("checkTimeoutMsToken", jwtExpDecode.exp);
        } else {
          console.log("> Lỗi get new refreshToken");
          // dispatch("logout");
        }
      } catch (error) {
        console.log("> Lỗi refreshToken", error);
      }
    } else {
      // dispatch("logout");
      router.push("/auth/login");
    }
  }
};
